function TagsList(props) {
  return (
    <div className="tag">
      <div className="tagText">{props.content}</div>
    </div>
  );
}

export default TagsList;
